import { Box, Spinner, Button, Inline } from "@adfenix/alexandria";
import { useQuery } from "@tanstack/react-query";
import {
  getHqCreditCardHistory,
  getOfficeCreditCardHistory
} from "api/services/stripeService";
import { useState } from "react";
import { AllTransactionsTable } from "./AllTransactionsTable";
import { GroupedTransactionsTable } from "./GroupedTransactionsTable";
import { useTranslation } from "react-i18next";

type Props =
  | { mode: "hq"; hqId: string; officeId?: undefined }
  | { mode: "office"; officeId: string; hqId?: undefined };

export const StripeTransactionHistory = ({ hqId, officeId, mode }: Props) => {
  const { t } = useTranslation();
  const [tableMode, setTableMode] = useState<"month" | "all">("all");
  const { data, isInitialLoading: isLoading } = useQuery(
    ["getHqCreditCardHistory", hqId],
    () =>
      mode === "hq"
        ? getHqCreditCardHistory(hqId ?? "")
        : getOfficeCreditCardHistory(officeId ?? ""),
    {
      enabled: Boolean(hqId) || Boolean(officeId)
    }
  );

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    );

  return (
    <Box>
      <Inline>
        <Button
          logLabel="show-all-transactions-button"
          variant="text"
          onClick={() => setTableMode("all")}
          style={{ textDecoration: tableMode === "all" ? "underline" : "none" }}
        >
          {t("billing_all_transactions")}
        </Button>
        <Button
          logLabel="show-monthly-transactions-button"
          variant="text"
          onClick={() => setTableMode("month")}
          style={{
            textDecoration: tableMode === "month" ? "underline" : "none"
          }}
        >
          {t("billing_monthly_statement")}
        </Button>
      </Inline>

      {tableMode === "all" ? (
        <AllTransactionsTable data={data} />
      ) : (
        <GroupedTransactionsTable
          mode={mode}
          subjectId={mode === "hq" ? hqId : officeId}
        />
      )}
    </Box>
  );
};
